import * as React from "react";
import { ITeam } from "core-integration/src/store/teams/types";
import styled from "styled-components";

const StyledBadge = styled.img`
  display: inline-block;
  vertical-align: middle;
`;

const badgePath = `/dist/img/badges`;
const prefix = "badge_";

interface IProps {
  className?: string;
  isPresentation?: boolean;
  sizes: string;
  team: ITeam | null;
}

const Badge: React.FC<IProps> = ({
  className,
  isPresentation,
  sizes,
  team,
}) => {
  const code = team ? team.code : 0;
  const path = `${badgePath}/${prefix}${code}`;

  const imgProps = {
    alt: team?.name || "",
    role: "",
    sizes,
    src: `${path}-50.png`,
    srcSet: `${path}-50.png 50w, ${path}-100.png 100w`,
  };

  if (isPresentation) {
    imgProps.alt = "";
    imgProps.role = "presentation";
  }

  return <StyledBadge className={className} {...imgProps} />;
};

export default Badge;
